import { apiFetchJson } from './apiClient';

export type CommunityMembershipStatus = 'none' | 'pending' | 'approved' | 'rejected';

export type CommunityMembershipState = {
  status: CommunityMembershipStatus;
  submittedAt: string | null;
  reviewWindowMs: number;
};

export function communityPathForStatus(status: CommunityMembershipStatus): string {
  switch (status) {
    case 'approved':
      return '/private-circle/community';
    case 'pending':
      return '/private-circle/application/pending';
    case 'rejected':
    case 'none':
    default:
      return '/private-circle';
  }
}

export async function fetchCommunityMembershipStatus(): Promise<CommunityMembershipState | null> {
  const result = await apiFetchJson<{ data: CommunityMembershipState }>(
    'GET',
    '/private-circle/membership/status',
    { withAuth: true },
  );
  if (!result.ok) return null;
  return result.data.data;
}
